"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var MobileTermsDialogComponent = /** @class */ (function () {
    function MobileTermsDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._isPopup = false;
    }
    Object.defineProperty(MobileTermsDialogComponent.prototype, "isPopup", {
        get: function () {
            return this._isPopup;
        },
        set: function (value) {
            this._isPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MobileTermsDialogComponent.prototype, "title", {
        get: function () {
            if (this.data.title != null) {
                return this.data.title;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    MobileTermsDialogComponent.prototype.ngOnInit = function () {
    };
    MobileTermsDialogComponent.prototype.closeAction = function () {
        if (this.isPopup)
            this.dialogRef.closeAll();
    };
    return MobileTermsDialogComponent;
}());
exports.MobileTermsDialogComponent = MobileTermsDialogComponent;
